<template lang="pug">
.forecast
  .section(v-for="(item,i) in forecastList" :key="i")
    .title
      .name
        span {{ item.stock_name }}
        span {{ item.stock_id }}
      .time.light 截止日期
        span {{ item.end_date }}
    .content
      .title.light 业绩变动说明
      .des {{ item.forecast_content }}
</template>

<script>
import { dateToDateStr } from '@utils/time_helper'
export default {
  name: 'Forecast',
  props: {
    list: Array
  },
  computed: {
    forecastList() {
      return this.list.map(item => {
        return {
          ...item,
          end_date: dateToDateStr(item.end_date)
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.forecast
  .section
    .title
      display flex
      justify-content space-between
      .name
        span
          &:last-child
            margin-left .36rem
            color #666
      .time
        span
          color #666
          margin-left .36rem
    .content
      background $box-bg-color
      padding .71rem .86rem
      border-radius .71rem
      margin-top .86rem
      .des
        margin-top .86rem

</style>
